import { GenIcon } from '../helpers/IconBase.es.js';

const RightOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { RightOutlined };
